// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pop .image[data-v-0c4a3d2b]{display:block;width:100%}.pop .form[data-v-0c4a3d2b]{position:absolute;top:0;left:0;right:0;z-index:2;padding:0 .53333rem;padding-top:1.86667rem}.pop .form1[data-v-0c4a3d2b],.pop .form2[data-v-0c4a3d2b]{position:relative}", ""]);
// Exports
module.exports = exports;
